import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-brand-dark relative border-t border-zinc-900" data-id="element-154">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-155">
        <FadeIn data-id="element-156">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-zinc-900 border border-zinc-800 mb-6" data-id="element-157">
            <ShieldIcon className="w-8 h-8 text-zinc-400" data-id="element-158" />
          </div>

          <h3 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide" data-id="element-159">
            GARANTÍA EN AMBAS OPCIONES
          </h3>

          <p className="text-xl text-zinc-300 font-medium mb-6" data-id="element-160">
            7 días de garantía total. Devolución del 100% sin preguntas.
          </p>

          <p className="text-zinc-400 leading-relaxed mb-6" data-id="element-161">
            Sea cual sea la opción que elijas — estás completamente protegido.
            Si por cualquier razón sentís que no es lo que prometemos,
            escribinos dentro de los 7 días posteriores a la compra y te
            devolvemos el dinero completo. Sin formularios. Sin preguntas. Sin
            demoras.
          </p>

          <p className="text-white font-bold" data-id="element-162">
            El riesgo es completamente nuestro. La solución es completamente
            tuya.
          </p>
        </FadeIn>
      </div>
    </section>;
}